import React, { useContext, useEffect } from "react";
import { RulesContext } from "../RulesContext";
import Select from "react-select";
import { CHANGE_RULE_WARNING } from "./RuleConstants";
import Bootbox from "../../../../Common/BootBoxManager";

const RuleCategorySelector = ({
  ruleBody,
  ruleDetails,
  setRuleDetails,
  ruleHeaderDetails,
  type
}) => {
  const {
    selectedCategories,
    setSelectedCategories,
    categoriesList,
    categoryTypesList,
    ruleState,
    setCompatibilityData,
    ruleDispatch,
  } = useContext(RulesContext);

  function generateCategorySelectOptions() {
    let categoriesGroupbyCT = categoriesList?.reduce((acc, category) => {
      (acc[category.cattypeid] = acc[category.cattypeid] || []).push({
        label: category.name,
        value: category.id,
      });
      return acc;
    }, {});

    let categoriesSelectOptions = categoryTypesList?.reduce(
      (accCt, categoryType) => {
        (accCt = accCt || []).push({
          label: categoryType.name,
          options: categoriesGroupbyCT[categoryType.id] || [],
        });
        return accCt;
      },
      []
    );

    return categoriesSelectOptions;
  }

  useEffect(() => {
    if (ruleBody) {
      setSelectedCategories((prevState) => {
        return {
          ...prevState,
          leftCategory: { id: ruleBody.leftCatID, name: "" },
          rightCategory: { id: ruleBody.rightCatID, name: "" },
        };
      });
    }
  }, [ruleBody]);

  const handle_change_categories = (id, catId, catName) => {
    setCompatibilityData([]);
    ruleDispatch({ type: "CBM_RULE_TYPE", data: [] });
    setRuleDetails((prev) => {
      return {
        ...prev,
        ...ruleHeaderDetails,
        rule_body: {},
      };
    });

    setSelectedCategories((prevState) => {
      return {
        ...prevState,
        [id]: { id: catId, name: catName },
      };
    });
  };

  const handleCategoryChange = (id, value, label) => {
    if (ruleState && ruleState.rule.length !== 0) {
      Bootbox.confirm(
        "Change Category?",
        CHANGE_RULE_WARNING,
        false,
        [handle_change_categories, id, value, label]
      );
    } else {
      handle_change_categories(id, value, label);
    }
  };

  return (
    <div className="tw-rounded-lg border border-[#E4E4E8] tw-bg-[#FAFAFC] tw-py-6 tw-px-2">
      {categoriesList && categoriesList.length > 0 && (
        <div className="mb-1 row d-flex justify-content-between ms-1 ps-1">
          <div
            className="row tw-flex tw-justify-between tw-items-center tw-text-[#090A42] tw-text-sm"
          >
            {" "}
            A
            <div
              className="col-sm-5 col-md-3 col-lg-4 col-xl-4 ms-2 me-2"
              style={{
                fontFamily: "Noto Sans",
              }}
            >
              <Select
                className="shadow-none "
                options={generateCategorySelectOptions()}
                isSearchable
                id="leftCategory"
                aria-label="RuleBody Status"
                value={
                  selectedCategories.leftCategory.id
                    ? {
                      value: selectedCategories.leftCategory.id,
                      label: selectedCategories.leftCategory.name,
                    }
                    : null
                }
                onChange={(e) =>
                  handleCategoryChange("leftCategory", e?.value, e?.label)
                }
                placeholder={"Select Category 1"}
                maxMenuHeight={220}
                menuPlacement="auto"
                isClearable={false}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isDisabled={type === 'copy' ? false : ruleDetails?.commit}
              />
            </div>
            is compatible with
            <div className="col-sm-5 col-md-3 col-lg-4 col-xl-4 ms-4 me-3">
              <Select
                className="shadow-none tw-rounded-md tw-bg-white"
                options={generateCategorySelectOptions()}
                isSearchable
                id="rightCategory"
                aria-label="RuleBody Status"
                value={
                  selectedCategories.rightCategory.id
                    ? {
                      value: selectedCategories.rightCategory.id,
                      label: selectedCategories.rightCategory.name,
                    }
                    : null
                }
                onChange={(e) =>
                  handleCategoryChange("rightCategory", e?.value, e?.label)
                }
                placeholder={"Select Category 2"}
                maxMenuHeight={220}
                menuPlacement="auto"
                isClearable={false}
                components={{
                  IndicatorSeparator: () => null,
                }}
                isDisabled={type === 'copy' ? false : ruleDetails?.commit}
              />
            </div>
            {""}
            if
          </div>
        </div>
      )}
    </div>
  );
};

export default RuleCategorySelector;
